import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterEmptyTxt, ResetFiltersBtn } from './resetFiltersAction.sc';

interface Props {
  primaryTextKey?: string;
  buttonTextKey?: string;
  clickFn: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const ResetFiltersAction: FC<Props> = ({
  clickFn,
  primaryTextKey = 'x.surveys.list.no_surveys_txt',
  buttonTextKey = 'x.surveys.list.reset_filters',
}) => {
  const [t] = useTranslation();
  return (
    <FilterEmptyTxt>
      <p data-translation={primaryTextKey}>{t(primaryTextKey)}</p>
      <ResetFiltersBtn data-translation={buttonTextKey} onClick={clickFn}>
        {t(buttonTextKey)}
      </ResetFiltersBtn>
    </FilterEmptyTxt>
  );
};

export default ResetFiltersAction;
